import { render } from "./graph-history-volume-detail.vue?vue&type=template&id=5211de06&scoped=true"
import script from "./graph-history-volume-detail.vue?vue&type=script&lang=js"
export * from "./graph-history-volume-detail.vue?vue&type=script&lang=js"

import "./graph-history-volume-detail.vue?vue&type=style&index=0&id=5211de06&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5211de06"]])

export default __exports__